<template>
  <div class="payment row">
      <iframe v-if="paymentUrl" :src="paymentUrl" frameBorder=0 id="paymentFrame" />
      <div v-else class="col-12 my-3 text-center">
          <!-- TODO strings -->
          Oops something went wrong, please try again
      </div>
  </div>
</template>

<script>

export default {
  name: "PaymentPage",
  props: ["paymentUrl", "type"],
  components: {

  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
#paymentFrame{
  margin-left:auto;
  margin-right:auto;
  height:1200px;
  margin-top:20px;
  width: 100%;
  max-width:100%
}
</style>
